import { useCallback } from 'react'
import { Modal } from '@workwhile/ui'
import { RemoveWorkerStep } from './steps/RemoveWorkerStep'
import { useAssignmentWorkflowsContextStateValue } from '../ScheduleContent/Calendar/context/AssignmentWorkflowsProvider'
import { useAssignmentDetailContextStateValue } from 'pages/AssignmentDetailPage/context'

export const RemoveWorkerFlow = () => {
  const { assignment } = useAssignmentDetailContextStateValue()
  const {
    removeWorkerFlow: { isOpen, close, worker, shift },
  } = useAssignmentWorkflowsContextStateValue()

  const handleClose = useCallback(() => {
    close()
  }, [close])

  return (
    <Modal open={isOpen} onClose={handleClose} width={600}>
      <RemoveWorkerStep
        assignmentId={assignment.id}
        worker={worker}
        shift={shift}
        onClose={handleClose}
      />
    </Modal>
  )
}
